import { useLocation } from "react-router-dom";
import { resolveSeo, useSeo } from "@/hooks/useSeo";

/**
 * 現在のパスに応じて title / description / canonical / OGP を適用する。
 * 画面には何も描画しない（SEO専用コンポーネント）。
 * SiteLayout に配置することで、全公開ページへ一括で反映される。
 */
export default function SeoManager() {
  const { pathname } = useLocation();
  const { title, description } = resolveSeo(pathname);

  useSeo({ title, description, pathname });

  return null;
}